import { render, staticRenderFns } from "./myExam.vue?vue&type=template&id=b314fec4&scoped=true&"
import script from "./myExam.vue?vue&type=script&lang=js&"
export * from "./myExam.vue?vue&type=script&lang=js&"
import style0 from "./myExam.vue?vue&type=style&index=0&id=b314fec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b314fec4",
  null
  
)

export default component.exports